module.exports = __webpack_public_path__ + "static/img/Daicos.02683a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Daicos.jpg
// module id = YzDv
// module chunks = 0